import {useEffect} from "react";

import {useAppDispatch} from "../../store/hooks";
import {hydrateReservedByMe} from "../state/reservation_slice";
import {readReservedMarkers} from "../utils/reservation_marker_storage";

// After mount only - the server render and the first client render both see no markers, so the hydration never mismatches
export const useReservedByMeHydration = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const markers = readReservedMarkers();

        if (Object.keys(markers).length > 0) {
            dispatch(hydrateReservedByMe(markers));
        }
    }, [dispatch]);
};
import {useEffect} from "react";

import {useAppDispatch} from "../../store/hooks";
import {hydrateReservedByMe} from "../state/reservation_slice";
import {readReservedMarkers} from "../utils/reservation_marker_storage";

// After mount only - the server render and the first client render both see no markers, so the hydration never mismatches
export const useReservedByMeHydration = () => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        const markers = readReservedMarkers();

        if (Object.keys(markers).length > 0) {
            dispatch(hydrateReservedByMe(markers));
        }
    }, [dispatch]);
};
